import { SET_LEAD_SOURCE_ID } from 'actions';

export function setLeadSourceId(leadSourceId: string) {
  return { leadSourceId, type: SET_LEAD_SOURCE_ID };
}
